import { PropertyKeyAvailableType } from '@acp/shared';
import { isAfter, isEqual, startOfTomorrow } from 'date-fns';
import { z } from 'zod';

const propertyKeySchema = z.object({
    onsiteAvailability: z.nativeEnum(PropertyKeyAvailableType),
    temporaryKeyExpirationDate: z.date().nullable(),
    keyOnsiteNotes: z.string().trim(),
}).refine((data) => {
    if (data.onsiteAvailability === PropertyKeyAvailableType.Temporary
        && data.temporaryKeyExpirationDate === null
    ) {
        return false;
    }

    return true;
}, {
    message: 'There must be an expiration date if key is temporarily available',
    path: ['temporaryKeyExpirationDate'],
}).refine((data) => {
    if (data.onsiteAvailability === PropertyKeyAvailableType.Temporary
        && data.temporaryKeyExpirationDate !== null) {
        const tomorrow = startOfTomorrow();
        return isAfter(data.temporaryKeyExpirationDate, tomorrow)
            || isEqual(data.temporaryKeyExpirationDate, tomorrow);
    }
    return true;
}, {
    message: 'Expiration date must be tomorrow or later',
    path: ['temporaryKeyExpirationDate'],
}).refine((data) => {
    if (data.onsiteAvailability !== PropertyKeyAvailableType.Unavailable
        && data.keyOnsiteNotes.length <= 5) {
        return false;
    }

    return true;
}, {
    message: 'Key onsite notes must be at least 5 characters long',
    path: ['keyOnsiteNotes'],
});

const editIntegratedPropertyFormSchema = z.object({
    propertyId: z.coerce.number().int().positive().gt(0)
        .finite(),
    propertyKey: propertyKeySchema.optional(),
});

type EditIntegratedPropertyFormValues = z.infer<
    typeof editIntegratedPropertyFormSchema
>;

export {
    editIntegratedPropertyFormSchema,
    EditIntegratedPropertyFormValues,
};
